$(document).ready(function() {
    // Bind the loadMore function to the click event on the anchor tag
    $('.js-load-more').on('click', loadMore);
});

function loadMore(event) {
    event.preventDefault(); // Prevent the default anchor behavior

    let maxProducts = Number($('.collection-products b:last-child').text());
    let currentProductsCount = $('.collection-page--list .product-item').length;

    var $this = $(this);
    var totalPages = parseInt($('[data-total-pages]').val());
    var currentPage = parseInt($('[data-current-page]').val());

    if (currentPage >= totalPages) {
        return;
    }

    $this.attr('disabled', true);
    $this.find('[loader]').removeClass('hide');

    currentPage++;

    var nextUrl = $('[data-next-url]').data('next-url');

    if (!nextUrl) {
        console.error('nextUrl not found');
        return;
    }

    nextUrl = nextUrl.replace(/page=[0-9]+/, 'page=' + currentPage);

    $('[data-current-page]').val(currentPage);

    $.ajax({
        url: nextUrl,
        type: 'GET',
        dataType: 'html',
        success: function(responseHTML) {
            $('.collection-page--list').append($(responseHTML).find('.collection-page--list').html());
            let productToPlus = $(responseHTML).find('.collection-page--list .product-item').length;
            let remainingProducts = maxProducts - currentProductsCount - productToPlus;
            if (remainingProducts <= 0 || !nextUrl) {
                $('.js-load-more').hide();
            }

            let productToShow = Number($('.collection-products b:first-child').text()) + productToPlus;
            $('.collection-products b:first-child').text(productToShow);
            $('.collection-page--sorting__info b:first-child').text(productToShow);
            $('.collection-progress-line').css('width', `${(productToShow / maxProducts) * 100}%`);
        },
        complete: function() {
            if(currentPage <= totalPages) {
                $this.attr('disabled', false);
                $this.find('[load-more-text]').removeClass('hide');
                $this.find('[loader]').addClass('hide');
            }
        }
    });
}